import { Affix, Menu } from "antd";
import { Header } from "antd/lib/layout/layout";
import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import * as img from "./img";;

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <Affix offsetTop={0}>
      <Header> 
        <motion.div
           whileHover={{ scale: 1.05 }}
           className="logo"
          style={{ backgroundColor: "White" }}
          onClick={() => navigate("/")}
        >
          <img src={img.logo} className="logofit" />
        </motion.div>

        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["null"]}
          inlineIndent={800}
          style={{
            display: "flex",
            justifyContent:"center",
            backgroundColor: "transparent",
            marginRight:"6vw"
          }}
          
        >
          <Menu.Item
            key="1"
           onClick={() => navigate("/")}
            style={{padding:"0 2vw 0"}}
          >
            Home
          </Menu.Item>
          <Menu.Item
            key="2"
            onClick={() => navigate("/project")}
            style={{padding:"0 3vw 0"}}
          >
            Projects
          </Menu.Item>
          
        </Menu>
      </Header>
     </Affix>
  );
};

export default Navbar;
